"use client";

import React from "react";

// All 28+ carriers with their logos
const ALL_CARRIERS = [
  { name: "Mutual of Omaha", logo: "/insurance logos/moo new png.png" },
  { name: "Americo", logo: "/insurance logos/americo new png.png" },
  { name: "American Home Life", logo: "/insurance logos/AHL NEW PNG.png" },
  { name: "Combined Insurance", logo: "/insurance logos/combined new png.png" },
  { name: "F&G", logo: "/insurance logos/fg new png.png" },
  { name: "Royal Neighbors", logo: "/insurance logos/royal new png.png" },
  { name: "American Amicable", logo: "/insurance logos/AA new png.png" },
  { name: "Liberty Bankers", logo: "/insurance logos/LIBERTYT BANKERS PNG.png" },
  { name: "Transamerica", logo: "/insurance logos/transamerica new png.png" },
  { name: "Corebridge", logo: "/insurance logos/corebridge new png.png" },
  { name: "Aetna", logo: "/insurance logos/aetna new png.png" },
  { name: "Foresters", logo: "/insurance logos/5d1121ad829994b960189b24_logo-foresters.png" },
  { name: "Allianz", logo: "/insurance logos/ALLIANZ NEW PNG.png" },
  { name: "Athene", logo: "/insurance logos/athene new png.png" }
];

export default function CarriersShowcase() {
  return (
    <section className="relative py-32 lg:py-40 overflow-hidden bg-slate-200">

      {/* Content */}
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative min-h-[700px] flex items-center justify-center py-24">
          {/* Orbiting Carriers */}
          <div className="absolute inset-0 flex items-center justify-center">
            {ALL_CARRIERS.map((carrier, index) => (
                <div
                  key={`orbit-${carrier.name}`}
                  className="absolute animate-orbit"
                  style={{
                    animationDelay: `-${(index / ALL_CARRIERS.length) * 40}s`
                  }}
                >
                  <div className="w-16 h-16 sm:w-20 sm:h-20 flex items-center justify-center hover:scale-110 transition-transform duration-300">
                    <picture>
                      <source
                        srcSet={carrier.logo}
                        type="image/png"
                      />
                      <img
                        src={carrier.logo}
                        alt={`${carrier.name} insurance carrier logo`}
                        className="w-full h-full object-contain"
                        loading="lazy"
                        decoding="async"
                        width="80"
                        height="80"
                      />
                    </picture>
                  </div>
                </div>
            ))}
          </div>

          {/* Center Content */}
          <div className="relative z-10 text-center max-w-2xl mx-auto">
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight mb-4">
              <span className="text-navy-900">Our </span>
              <span className="text-navy-700">Carrier Partners</span>
            </h2>
            
            <p className="text-lg text-neutral-gray-600 mb-8">
              We've partnered with <strong className="text-navy-700">28+ industry-leading carriers</strong> to provide you with the best products and <strong className="text-navy-600">highest commission rates</strong>.
            </p>

            {/* Stats section */}
            <div className="flex flex-wrap items-center justify-center gap-4 sm:gap-6 text-lg sm:text-xl font-semibold text-gray-600">
              <span>28+ Carrier Partners</span>
              <span>A+ Rated Financial Strength</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}